import { StoryblokComponent, storyblokEditable } from "@storyblok/react";

const PageNoDemo = ({ blok }) => (
  <>
    <main {...storyblokEditable(blok)} className="no-demo">
      {blok.pagecontent
        ? blok.pagecontent.map((blok) => (
            <StoryblokComponent blok={blok} key={blok._uid} />
          ))
        : null}
    </main>
  </>
);

export default PageNoDemo;
